/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// Packages
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Components (View)
import CreateEditJobView from './CreateEditJobView'

// Styles
import { Spin } from 'antd'

const CreateEditJobIndex = () => {
	const [renderReady, setRenderReady] = useState(false)
	const [isCreate, setIsCreate] = useState(null)
	const [editState, setEditState] = useState(null)
	const location = useLocation()
	
	const checkPropsForState = () => {
		// Pathname must be available to determine modes
		if (location && location.pathname) {
			// Edit Mode
			if (location.pathname === '/joblist/edit') {
				setIsCreate(false)
				if (location.state) {
					setEditState(location.state)
					setRenderReady(true)
				}
				// Create Mode
			} else {
				setIsCreate(true)
				setEditState({})
				setRenderReady(true)
			}
		}
	}
  
	useEffect(() => {
		checkPropsForState()
	}, [location])

	return (
		<>
			{!renderReady &&
        <div style={{ padding: '5rem 0', textAlign: 'center' }}>
        	<Spin />
        </div>}
			{renderReady && (isCreate !== null) && (editState !== null) &&
        <CreateEditJobView isCreate={isCreate} state={editState} />}
		</>
	)
}

export default CreateEditJobIndex
